import { useTranslation } from "react-i18next";

export default function StripeRedirectingOverlay({ show }) {
  const { t } = useTranslation();
  if (!show) return null;
  return (
    <div style={{
      position: "fixed",
      inset: 0,
      zIndex: 9999,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "rgba(255, 255, 255, 0.50)",
      backdropFilter: "blur(3px)",
      WebkitBackdropFilter: "blur(3px)",
      gap: "24px",
      padding: "24px",
      textAlign: "center"
    }}>
      <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
        <span className="visually-hidden">{t("Loading")}...</span>
      </div>
      <h5 style={{ fontWeight: 600, margin: 0 }}>
        {t("You are being redirected to the payment page...")}
      </h5>
      <p style={{ color: "#666", maxWidth: "400px", margin: 0 }}>
        {t("Please do not close or reload this page. You will be redirected shortly.")}
      </p>
    </div>
  );
}
